export const get = (name) =>
  function* ({ cookies }) {
    try {
      return cookies.get(name);
    } catch (e) {
      return null;
    }
  };

export const set = (name, value, daysToExpire, options = {}) =>
  function* ({ cookies }) {
    return cookies.set(name, value, daysToExpire, options);
  };
